import { Component } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { DdcAdCarouselComponent } from 'src/app/shared/ddc/ddc-ad-carousel/ddc-ad-carousel.component'
import { DdcLogoComponent } from 'src/app/shared/ddc/ddc-logo/ddc-logo.component'

@Component({
  selector: 'ddc-under-construction',
  imports: [DdcLogoComponent, RouterModule, DdcAdCarouselComponent],
  templateUrl: './ddc-under-construction.component.html',
  styleUrl: './ddc-under-construction.component.scss',
})
export class DdcUnderConstructionComponent {
  constructor(private router: Router) {}

  goToLogin(): void {
    this.router.navigate(['/login'])
  }
}
